import { render } from "./TestForm.vue?vue&type=template&id=4ade3b3d&scoped=true"
import script from "./TestForm.vue?vue&type=script&lang=js"
export * from "./TestForm.vue?vue&type=script&lang=js"

import "./TestForm.vue?vue&type=style&index=0&id=4ade3b3d&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ade3b3d"]])

export default __exports__